import { html, LitElement } from 'lit';

class IconCheckboxChecked extends LitElement {
  static properties = {
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    strokeColor: {
      type: String,
      attribute: 'stroke-color',
    },
    fillColor: {
      type: String,
      attribute: 'fill-color',
    },
  };

  constructor() {
    super();
    this.height = '16';
    this.width = '16';
    this.strokeColor = '#0079dd';
    this.fillColor = '#0079dd';
  }

  render() {
    return html`
      <svg display="inline-block" width="${this.width}" height="${this.height}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect stroke="${this.strokeColor}" fill="${this.fillColor}" x="1" y="1" width="14" height="14" rx="2" strokeWidth="2" />
        <path fill="white" fill-rule="evenodd" clip-rule="evenodd" d="M13.7071 4.29289C14.0976 4.68342 14.0976 5.31658 13.7071 5.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071L2.29289 9.70711C1.90237 9.31658 1.90237 8.68342 2.29289 8.29289C2.68342 7.90237 3.31658 7.90237 3.70711 8.29289L6 10.5858L12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289Z" />
      </svg>
    `;
  }
}
customElements.define('tenable-icon-checkbox-checked', IconCheckboxChecked);
